import React from 'react'

import ChartWrapper from '../ChartWrapper'
import Chart from './FocusChart.d3'

const FocusChart = ({
  data,
  events,
  tickerId,
  animateInitialDraw,
  toggleProps,
  transform,
  setTransform,
  selection,
  registerFocusChartTimeChange,
  currency,
  sizeTrigger,
}) => {
  const triggerZoom = event => {
    setTransform(event)
  }

  const updateProps = React.useMemo(
    () => ({ data, events, tickerId }),
    [data, events, tickerId],
  )

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{
        data,
        events,
        tickerId,
        animateInitialDraw,
        triggerZoom,
        registerFocusChartTimeChange,
        currency,
      }}
      updateProps={updateProps}
      toggleProps={toggleProps}
      margin={{ BOTTOM: 20, LEFT: 0 }}
      useBrush
      brushProps={selection}
      useZoom
      useToggle
      zoomProps={transform}
      sizeTrigger={sizeTrigger}
    />
  )
}

export default FocusChart
